<template>
    <div>
        <div class="d-flex justify-content-between p-4">
            <div class="col-2 pl-0 pr-0">
                <span class=" proximanova fontsize14 black">Analytics Report</span>
            </div>
            <div class="d-flex justify-content-end d-md-flex">
                <span class="proximanova black60 fontsize10 pt-2 d-none d-md-block">{{fromDate}} to {{toDate}}</span>     
                <div class="ml-2 mr-2">
                    <a  class="btn button-create btn-color "  id="search">
                        <span class="proximanova black60 fontsize10 my-auto">{{selectedStatusCode}}</span>
                        <img src="../assets/Dropdown.svg" alt="dropdown" class="img-fluid p-2" />      
                        <date-range-picker
                            ref="picker"
                            opens="left"
                            :locale-data="locale"
                            :ranges="ranges"
                            v-model="dateRange"
                            @update="getchartData"                          
                        ></date-range-picker>                  
                    </a>      
                           
                </div>
            </div>
        </div>
        <div  v-if="chartData.length > 0 && entitlements.viewedPercentageGraph === 'Y'" >
            <highcharts class="hc" :options="chartOptions"></highcharts>
        </div>
        <div v-else class="text-center p-4 pb-5">
            <span class="proximanova-semibold fontsize14 black" v-if="entitlements.viewedPercentageGraph === 'Y'">No chart data available between selected dates</span>
            <span class="proximanova-semibold fontsize14 black" v-else>Please Subscribe to any Plan to view the information</span>
        </div>
    </div>
</template>
<script>
 import DateRangePicker from 'vue2-daterange-picker'
 import moment from 'moment'
 import $ from "jquery";
import httpuserprofile from '../js/http-userprofile.js'
 import sessionUtils from '@/js/session-util.js'
export default{
    props: [
        'planObject'
    ],
    data(){
        return{
            entitlements : {},
            subscriptionStatus :'N',
            selectOptions: ['Last 7 Days','15 Days','30 Days','3 Months','6 Months','12 Months','Custom Range'],
            selectedStatusCode: 'Last 7 Days',
            fromDate: '25 may, 2021',
            toDate: '31 may, 2021',
            fromDateCustom: "",
            toDateCustom: "",
            dateRange: {
                startDate: '2021-06-01',
                endDate: '2021-08-12',
            },
            series: [],
            locale: {
                direction: 'rtr',
                format: 'mm/dd/yyyy',
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                firstDay: 0
            },
            ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
                'Last 7 Days': [],
                '15 Days': [],
                '30 Days': [],
                '3 Months': [],
                '6 Months': [],
                '12 Months': [],
            },
            chartData: [],
            
            
            chartOptions: {
                chart: {
                    type: 'areaspline'
                },               
                title: {
                    text: ''
                },
                legend: {
                    enabled:false
                },
        
                xAxis: {
                    gridLineWidth: 1,
                    visible: true,
                    // categories:  ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
                    lineColor:'#007AFF',    
                },   
                yAxis: {
                    gridLineWidth: 1,
                    // min: 0,
                    // max:10,
                    title: {
                        text: ' '
                    },
                    plotLines: [ {
                        // value: 2,
                        color: '#007AFF',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: ''
                        }
                    }]
                },
                tooltip: {
                    enabled:false
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        stacking: 'percent',
                        pointPadding: 0.2,
                        borderWidth: 0,
                        pointWidth: 15
                    }
                },  
                series: [ {
                    name: 'Jane',
                    color: '#d1e7ff',
                    lineColor:'#007AFF',   
                    lineWidth: 1,         
                    marker: {
                        fillColor: 'white',
                        lineWidth: 1,
                        lineColor: '#007AFF'
                    },  
                    data: this.chartData      
                }]
            },
        }
    },
    components:{
        DateRangePicker
    },
    watch:{
        chartData(){this.redraw()},
    },
    mounted(){
        this.entitlements = JSON.parse(localStorage.getItem('entitlements'))
        console.log(this.entitlements)
        if(this.planObject !== undefined && typeof(this.planObject) !== undefined){
            console.log(this.planObject)
            this.subscriptionStatus = this.planObject.status;        
        }   
            this.getchartData();
      
    },
    methods:{
        dateFormat (classes, date) {
        if (!classes.disabled) {
          classes.disabled = date.getTime() < new Date()
        }
        return classes
      },
      //fetch chart data based on selected dates
      getchartData(){   
          console.log('entre into get chart data')       
          var fromDate = moment(this.dateRange.startDate).format('yyyy-MM-DD');
          var toDate =   moment(this.dateRange.endDate).format('yyyy-MM-DD');
          httpuserprofile.get("/userprofile/userviewedChartData?profileId="+sessionUtils.getUserProfileId()+"&fromDate="+fromDate+"&toDate="+toDate)
          .then((response) => {
            console.log(response)
            if(response.data.list === null || response.data.list === undefined){
                this.chartData = []
            }
            if(response.data.list){
                this.chartData = response.data.list;
                console.log(this.chartData)
            }             
          });
      },
      redraw(){   
        var that = this;     
    	this.chartOptions.series[0].data = this.chartData.map(function (point) {
            return [point.createdatetimestamp, point.count]
        })
        this.chartOptions.xAxis.categories = []
        this.chartData.forEach((point) =>{
            let x = point.createdatetimestamp
            that.chartOptions.xAxis.categories.push(x)
        });
        var hightPeak = 0;
        this.chartData.forEach((point) =>{
            let y = point.count
            if(hightPeak <= y) {
                hightPeak = y
            }
        });
        this.chartOptions.yAxis.plotLines[0].value = hightPeak
       console.log(this.chartOptions.yAxis.plotLines[0])
    },
      updateValues(){    
          var dataObj = []    
        this.fromDateCustom = new Date(this.dateRange.startDate);
        this.toDateCustom = new Date(this.dateRange.endDate);        
        chartData.filter(d => {var time = new Date(d.date).getDate();            
            if (this.fromDateCustom.getDate() < time && time < this.toDateCustom.getDate()){
                dataObj.push([d.date,d.value])
            }
        });        
      }
    },
}
</script>
<style scoped>
@import '../css/vue2-daterange-picker.css';
.center-content{
    margin: 0;
    /* background: yellow; */
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
}
.form-control{
    height: unset !important;
    font-size: 12px;
}
.form-control:focus{
   border: none;
}
.btn-color{
  border-color: #D9DCE1;
  padding: 0px 1px
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
  padding: .075rem 0.25rem !important;
  /* transition: border 8s; */
}
.calendars{
    flex-wrap: nowrap;
}
.dob{
    z-index:4
}
.button-cancel1{
  opacity: 1;
  /* color: yellow; */
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
  -webkit-background-clip: text;
-webkit-text-fill-color: transparent;
  border: 2px solid transparent;
  border-radius: 10px !important;
  -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
  border-image-slice: 1;
}
.dropdown-position-bottom.profileStrengthpop {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width:90% !important;
    left: unset !important;
    transform: translate3d(-85%,0px,0px);
    
  }
 .vue-popover.dropdown-position-bottom.profileStrengthpop:before {
    display: none !important;
  }
 .profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1);
  opacity:0.4
}
.hc{
    height: 220px;
    width: 100%;
    zoom:1;
}
@media screen and (max-width: 1140px ) and (min-width: 992px) {
  .dropdown-position-bottom.profileStrengthpop {   
    transform: translate3d(-72%,0px,0px);    
  }
}
@media screen and (max-width: 500px) {
  .dropdown-position-bottom.profileStrengthpop {   
    transform: translate3d(-72%,0px,0px);    
  }
}
</style>
